import { render, staticRenderFns } from "./DefaultContainer_2.vue?vue&type=template&id=752f8529&"
import script from "./DefaultContainer_2.vue?vue&type=script&lang=js&"
export * from "./DefaultContainer_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports